<template>
  <div>
    <div id="container" class="container" :style="{ height: height+'px' }">
    </div>
  </div>
</template>

<script>
import Pdfh5 from "pdfh5";
import "pdfh5/css/pdfh5.css";
import axios from 'axios'
export default {
  props: {
    height: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      pdfDoc: null,
      width: 360,
      scale: 1,
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.width = document.documentElement.clientWidth - 20
      // let containerHeight = document.documentElement.clientHeight - document.getElementById("container").offsetTop
      // alert(containerHeight)
    })
  },
  methods: {
    getParams (url) {
      // url = 'http://appdata-dev.derunht.cn/api///upload/5b623aca7af14525bc27f2a11ec28d1f.pdf'
      if (url) {
        // this.getPdf(url)
        this.initPdf(url)
      }
    },
    initPdf (url) {
      // pdfh5实例化时传两个参数：selector选择器，options配置项参数，会返回一个pdfh5实例对象，可以用来操作pdf，监听相关事件
      // 1.直接url
      // this.pdfh5 = new Pdfh5("#container", {
      //   pdfurl: url,
      // goto: 1,
      // renderType: 'svg',
      // lazy: true,
      // pageNum: false
      // });
      // this.pdfh5.scrollEnable(true); // 允许pdf滚动
      // // 监听pdf准备开始渲染，此时可以拿到pdf总页数
      // this.pdfh5.on("ready", function () {
      //   //console.log("总页数:" + this.totalNum);
      // });
      // // 监听pdf加载完成事件，加载失败、渲染成功都会触发
      // this.pdfh5.on("complete", (status, msg, time) => {
      //   //console.log("状态:" + status + "，信息:" + msg + "，耗时:" + time + "毫秒");
      // });
      // 2.data
      this.$toast.loading({
        duration: 0,
        forbidClick: false,
        message: '加载中...',
        overlay: true
      });
      axios.get(url, {
        responseType: "arraybuffer"
      }).then(res => {
        this.$toast.clear()
        this.pdfh5 = new Pdfh5('#container', {
          data: res.data,
          goto: 1,
          renderType: 'canvas', // "canvas"、"svg"，默认"canvas"	pdf渲染模式
          lazy: true,
          pageNum: false, // 是否显示左上角页码
          backTop: false, // 是否显示右下角回到顶部按钮
        });
        this.pdfh5.scrollEnable(true); // 允许pdf滚动
        // 监听pdf准备开始渲染，此时可以拿到pdf总页数
        this.pdfh5.on("ready", function () {
          //console.log("总页数:" + this.totalNum);
        });
        // 监听pdf加载完成事件，加载失败、渲染成功都会触发
        this.pdfh5.on("complete", (status, msg, time) => {
          //console.log("状态:" + status + "，信息:" + msg + "，耗时:" + time + "毫秒");
        });
      }).catch(err => {
        this.$toast.clear()
      })
    },
    getPdf (url) {
      let _that = this
      PDFJS.getDocument(url).then(function (pdf) {
        _that.pdfDoc = pdf;
        if (pdf.numPages > 0) {
          for (var i = 1; i <= _that.pdfDoc.numPages; i++) {
            _that.renderPage(i)
          }
          // _that.getScale(() => {

          // })
        }
      });
    },
    getScale (callback) {
      // let _that = this
      this.pdfDoc.getPage(1).then(function (page) {
        // let viewport = page.getViewport(1);
        // let viewportWidth = viewport.width
        // if (viewportWidth > _that.width) {
        //   _that.scale = _that.width / viewportWidth
        // } else if (viewportWidth < _that.width) {
        //   _that.scale = viewportWidth / _that.width
        // } else {
        //   _that.scale = 1;
        // }
        callback()
      })
    },
    renderPage (num) {
      let _that = this
      this.pdfDoc.getPage(num).then(function (page) {
        // 2倍放大页面使pdf清晰
        var viewport = page.getViewport(3);
        var canvas = _that.createPage();
        var ctx = canvas.getContext('2d');

        canvas.height = viewport.height;
        canvas.width = viewport.width;
        // 限制显示大小一屏宽度
        canvas.style.width = _that.width + 'px'

        page.render({
          canvasContext: ctx,
          viewport: viewport
        });
      });
    },
    createPage () {
      let containerDiv = document.getElementById('container')
      var div = document.createElement("canvas");
      containerDiv.appendChild(div);
      return div;
    },
  }
}
</script>

<style scoped>
canvas {
  width: 100%;
  height: 100%;
  border: 1px solid black;
}

.container {
  width: 100%;
  overflow: auto;
  position: relative;
  bottom: 0;
  left: 0;
}
</style>


// WEBPACK FOOTER //
// src/views/my/previewPdfContent.vue